import { useState, useEffect } from 'react';
import { DEFAULT_CONDITION_ID } from '../utils/ebay/ebayListingText';

const STORAGE_KEY = 'ebay_prefs';

const DEFAULTS = {
    categoryId:    '261328',  // Baseball Cards
    conditionId:   DEFAULT_CONDITION_ID,
    defaultFormat: 'FixedPrice',
    defaultPrice:  '1',
};

function loadPrefs() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        return raw ? { ...DEFAULTS, ...JSON.parse(raw) } : { ...DEFAULTS };
    } catch {
        return { ...DEFAULTS };
    }
}

function savePrefs(prefs) {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs));
    } catch {}
}

/**
 * Persisted eBay export defaults.
 * Stored separately from Whatnot prefs under 'ebay_prefs' in localStorage.
 */
export function useEbayPrefs() {
    const [prefs, setPrefs] = useState(loadPrefs);

    useEffect(() => {
        savePrefs(prefs);
    }, [prefs]);

    const setCategoryId    = (v) => setPrefs((p) => ({ ...p, categoryId: v }));
    const setConditionId   = (v) => setPrefs((p) => ({ ...p, conditionId: v }));
    const setDefaultFormat = (v) => setPrefs((p) => ({ ...p, defaultFormat: v }));
    const setDefaultPrice  = (v) => setPrefs((p) => ({ ...p, defaultPrice: v }));

    return { ...prefs, setCategoryId, setConditionId, setDefaultFormat, setDefaultPrice };
}

/** Read-once helper for non-hook contexts (e.g. checklist add). */
export function getEbayPrefs() {
    return loadPrefs();
}
